import FamilyRecordsModule from '../components/FamilyRecordsModule'

export default function Tasks(){
 return <FamilyRecordsModule module="tasks"/>
}
